/**
 * @param {Number} phone
 * @returns {Boolean}
 */
export function isPhone(phone) {
    return (/^1[3456789]\d{9}$/.test(phone))
}
/**
 * @param {String} emial
 * @returns {Boolean}
 */
 export function isEmail(emial) {
    return (/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(emial))
}